import { Link } from "react-router-dom";
import { FaRegBuilding, FaChevronRight, FaPills } from "react-icons/fa";
import { RiLoader3Line, RiMedicineBottleLine } from "react-icons/ri";
import { MdCategory, MdCompareArrows } from "react-icons/md";
import TopBrandBadge from "../commons/TopBrandBadge";
import { useCompare } from "../../hooks/useCompare";

export default function TradenameCard({ item, isLastItem, lastItemRef, isFeature = false, isHideDetails = false }) {
    const { isSelected, toggleItem, isFull } = useCompare();
    const selected = isSelected(item.uri);
    const disabled = !selected && isFull;

    const handleCompareToggle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (disabled) return;
        toggleItem(item);
    };

    return (
        <Link
            key={item._id}
            ref={isLastItem ? lastItemRef : null}
            to={`/tradenames/${item.uri}`}
            className="h-full"
        >
            <div className={`relative flex p-4 h-full min-h-[120px] overflow-hidden transition-all duration-200 border bg-white/40 backdrop-blur-sm group rounded-xl hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary/30 ${isFeature
                ? 'border-white/60 hover:border-primary/40 shadow-md hover:shadow-xl'
                : 'border-white/60'
                } ${selected ? 'ring-2 ring-primary/30 border-primary/30' : ''}`}>

                {/* Compare checkbox */}
                <button
                    onClick={handleCompareToggle}
                    className={`absolute top-3 right-3 flex items-center justify-center size-9 rounded-lg transition-all z-[1] ${selected
                        ? 'bg-primary text-white shadow-sm'
                        : disabled
                            ? 'bg-secondary/5 text-secondary/20 cursor-not-allowed'
                            : 'bg-white/90 text-secondary/60 hover:text-primary hover:bg-primary/10 border border-secondary/10'
                        }`}
                    aria-label={selected ? `Remove ${item.name} from comparison` : `Add ${item.name} to comparison`}
                    title={disabled ? "Maximum 4 items selected" : selected ? "Remove from comparison" : "Add to comparison"}
                >
                    <MdCompareArrows className="size-4" />
                </button>

                <div className="flex-shrink-0 mr-3">
                    <div className={`flex items-center justify-center transition-colors rounded-full w-10 h-10 bg-primary/10 text-primary group-hover:bg-primary/20`}>
                        <RiMedicineBottleLine className="size-5" />
                    </div>
                </div>
                <div className="flex-1 min-w-0">
                    <div className={`font-medium transition-colors text-16 leading-snug ${isFeature
                        ? 'text-secondary group-hover:text-primary inline-block group-hover:text-transparent group-hover:bg-gradient-title group-hover:bg-clip-text'
                        : 'text-secondary group-hover:text-primary'
                        }`}>
                        {item.name.replace("&amp;", "&")}
                    </div>

                    <div className="flex items-center gap-2 mt-1.5 text-14 text-secondary/70">
                        <FaRegBuilding className="min-size-4 max-size-4 text-secondary/60" />
                        <span className="w-full truncate transition-colors font-text">
                            {item.manufacturers[0]?.name || 'Unknown Manufacturer'}
                        </span>
                    </div>
                    {item.forms?.[0]?.[0] && !isHideDetails && (
                        <div className="flex items-center gap-2 mt-1.5 text-14 text-secondary/70">
                            <FaPills className="min-size-4 max-size-4 text-secondary/60" />
                            <span className="w-full truncate transition-colors font-text">
                                {item.forms[0][0]}
                            </span>
                        </div>
                    )}
                    {item.categories?.length > 0 && !isHideDetails && (
                        <div className="flex items-center gap-2 mt-1.5 text-14 text-secondary/70">
                            <MdCategory className="min-size-4 max-size-4 text-secondary/60" />
                            <span className="w-full truncate transition-colors font-text">
                                {item.categories.length} {item.categories.length === 1 ? 'category' : 'categories'}
                            </span>
                        </div>
                    )}

                    {(isFeature || item.is_sponsor) && (
                        <TopBrandBadge />
                    )}
                </div>

                <div className="self-center ml-2 -mr-1 transition-transform transform group-hover:translate-x-1">
                    <div className="p-1 rounded-full text-secondary/40 group-hover:text-primary">
                        <FaChevronRight className="size-3" />
                    </div>
                </div>
            </div>
        </Link>
    );
}

// Skeleton
export function TradenameCardSkeleton() {
    return (
        <div className="">
            <div className="flex p-3">
                <div className="flex-shrink-0 mr-3">
                    <div className="flex items-center justify-center transition-colors rounded-full w-9 h-9 bg-primary/10 text-primary group-hover:bg-primary/20">
                        <RiLoader3Line className="size-4 animate-spin" />
                    </div>
                </div>
                <div className="flex-1 min-w-0 w-full">
                    <div className="font-medium text-15 text-secondary align-middle my-auto py-1">
                        Loading...
                    </div>
                </div>
            </div>
        </div>
    );
}
